module.exports = __webpack_public_path__ + "assets/img/32_622.c17cab59.jpg";